<div class="grid">
  <app-flag-icon [code]="iso"></app-flag-icon>
  <mat-label>{{ name }}</mat-label>
</div>
